/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Fragment } from 'react';
import EnvelopeWithBox from '../components/EnvelopeWithBox';
import BorrowerLoginAuditForm from '../components/forms/BorrowerLoginAuditForm';
import Style from '../css/BorrowerLoginAudit.module.css';

export default function BorrowerLoginAuditPage() {
  return (
    <Fragment>
      <EnvelopeWithBox blockName='Borrower Login Audit'>
        <BorrowerLoginAuditForm></BorrowerLoginAuditForm>
      </EnvelopeWithBox>
    </Fragment>
  );
}
